import { useEffect, useState } from 'react';
import { Input } from '../../../common/Forms/Input/Input';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as schemas from '../../../../assets/schemas/schemas';
import { ActionButton } from '../../../common/Buttons/Buttons';
import {
  capitalize,
  filterParams,
  returnMissingFields,
  removeSpecialCharsAndUppercase,
  validateIfOther,
  filterById,
  filterOptionById,
} from '../../../../assets/helpers/funciones';
import {
  idCodes,
  affiliationTypeOptions,
  vehicleWeightOptions,
  vehiclesEnum,
  vehicleUsageOptions,
  vehicleUsageEnum,
  planStatus,
  getVehicleBrandsPlanParam,
} from '../../../../assets/helpers/options';
import { statesService } from '../../../../services/statesService';
import { vehicleService } from '../../../../services/vehicleService';
import { membershipService } from '../../../../services/membershipService';
import { economicActivitiesService } from '../../../../services/economicActivitiesService';
import { notify } from '../../../../assets/helpers/toast';
import { armoredOptions } from '../../../../assets/helpers/options';
import { OderCardHeader } from './OrderComponents';
import {
  MissingDocumentsModal,
  MissingFieldsModal,
  ChangeVehicleModal,
  VehicleChangeHistoryModal,
  VehicleSoldModal,
} from '../../../common/Modals/Modals';
import { vehicleChangeHistoryHeader } from '../../../../assets/helpers/tables';
import { LoadSpinner } from '../../../common/LoadSpinner/LoadSpinner';
import { salesRoles } from '../../../../assets/helpers/roles';
import authService from '../../../../services/authService';
import './OrderComponent.scss';
import { RcvHolderFormForAffiliationCard } from '../../../common/Forms/Form';

const resolveVehicleClassId = (classes, vehicle) => {
  if (!vehicle || !classes?.length) return '';

  const { classId, class: classValue } = vehicle;

  if (classId) {
    const match = filterOptionById(classes, classId);
    if (match?._id) return match._id;
  }

  if (classValue) {
    const matchById = filterOptionById(classes, classValue);
    if (matchById?._id) return matchById._id;

    const normalizedClass = String(classValue).toLowerCase();
    const matchByName = classes.find(
      (option) => option?.name?.toLowerCase() === normalizedClass
    );
    if (matchByName?._id) return matchByName._id;
  }

  return classId || '';
};

export const VehicleInfoCard = (props) => {
  const { label, membership, reloadMembership } = props;
  const [statesOptions, setStatesOptions] = useState([]);
  const [citiesOptions, setCitiesOptions] = useState([]);
  const [vehicleFilerUsageOptions, setVehicleFilerUsageOptions] = useState([]);
  const [RCVCitiesOptions, setRCVCitiesOptions] = useState([]);
  const [economicActivitiesOptions, setEconomicActivitiesOptions] = useState(
    []
  );
  const [ownercitiesOptions, setOwnerCitiesOptions] = useState([]);
  const [vehicleChangeOwnercitiesOptions, setVehicleChangeOwnerCitiesOptions] =
    useState([]);
  const [customerIsOwner, setcustomerIsOwner] = useState('SI');
  const [vehicleBrandOptions, setVehicleBrandOptions] = useState([]);
  const [vehicleModelOptions, setVehicleModelOptions] = useState([]);
  const [vehicleChangeModelOptions, setVehicleChangeModelOptions] = useState(
    []
  );
  const [vehicleClassesOptions, setVehicleClassesOptions] = useState([]);
  const [
    vehicleChangeMunicipalitiesOptions,
    setVehicleChangeMunicipalitiesOptions,
  ] = useState([]);
  const [municipalitiesOptions, setMunicipalitiesOptions] = useState([]);
  const [typesOptions, setTypesOptions] = useState([]);
  const [vehicleChangetypesOptions, setVehicleChangeTypesOptions] = useState(
    []
  );
  const [isLoading, setIsloading] = useState(false);
  const [changeVehicleModal, setChangeVehicleModal] = useState({
    isOpen: false,
  });
  const [changeVehicleSoldModal, setChangeVehicleSoldModal] = useState({
    isOpen: false,
  });
  const [missingFieldsModal, setMissingFieldsModal] = useState({
    isOpen: false,
    missingFields: [],
  });
  const [missingDocumentsModal, setMissingDocumentsModal] = useState({
    isOpen: false,
    missingDocuments: [],
  });
  const [vehicleHistoryModal, setVehicleHistoryModal] = useState({
    isOpen: false,
  });

  const [open, setOpen] = useState(true);

  const isPendingDocumentation =
    membership?.membershipStatus === planStatus.PENDING_DOCUMENTATION;

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
  } = useForm({
    resolver: yupResolver(schemas.orderVehicleInfoForm()),
  });

  const {
    register: register2,
    handleSubmit: handleSubmit2,
    formState: { errors: errors2 },
    watch: watch2,
    reset: reset2,
    setError: setError2,
  } = useForm({
    resolver: yupResolver(schemas.changeVehicleSchema()),
  });

  const changeVehicle = handleSubmit2(async (data) => {
    let dataToPost = { ...data };

    if (validateTruck(watch2) && !data?.truckWeight) {
      setError2('truckWeight', { type: 'custom', message: 'Obligatorio' });
      return null;
    }

    dataToPost.membershipId = membership?._id;

    dataToPost = filterParams(dataToPost);

    if (!isLoading) {
      setIsloading(true);
      membershipService
        .changeVehicle(dataToPost)
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            notify(`Cambio de vehiculo`, 'success');
            reloadMembership();
            setIsloading(false);
            handleChangeVehicleModal();
            window.location.reload();
          } else {
            notify(`${response.message}`, 'error');
            setIsloading(false);
          }
        })
        .catch((error) => {
          setIsloading(false);
        });
    }
  });

  const getEconomicActivities = () => {
    return economicActivitiesService
      .getEconomicActivities()
      .then((response) => {
        if (response.status === 200) {
          setEconomicActivitiesOptions(response?.data?.activities);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
        return response;
      })
      .catch(() => {});
  };

  /** Lets React commit option lists to state before setValue on dependent selects. */
  const waitForNextPaint = () =>
    new Promise((resolve) => {
      requestAnimationFrame(() => requestAnimationFrame(resolve));
    });

  const preloadForm = async () => {
    const v = membership?.vehicle;
    const c = membership?.customer;
    const r = membership?.rcvHolder;
    if (!v) return;

    if (v.customerIsOwner) {
      setcustomerIsOwner('SI');
    } else {
      setcustomerIsOwner('NO');
    }
    setValue('customerIsOwner', v.customerIsOwner);

    setValue('ownerFirstName', v.ownerFirstName);
    setValue('ownerLastName', v.ownerLastName);
    setValue('ownerIdentificationType', v.ownerIdentificationType);
    setValue('ownerIdentification', v.ownerIdentification);
    setValue('engineSerial', v.engineSerial);
    setValue('profession', c?.profession);
    setValue('truckWeight', v.truckWeight);
    setValue('seats', v.seats);
    setValue('rcvHolderState', r?.state);

    await Promise.all([
      getStates(),
      getEconomicActivities(),
      getVehicleBrands(),
    ]);

    const classesResponse = await getSalesVehicleClasses(membership);
    const classes =
      classesResponse?.status === 200 ? classesResponse?.data?.classes : [];
    const classId = resolveVehicleClassId(classes, v);

    await waitForNextPaint();
    setValue('class', classId);

    if (classId) {
      await getVehicleTypes(classId, false);
      await waitForNextPaint();
    }
    setValue('type', v.typeId);
    setValue('class', classId);

    if (v.brandId) {
      setValue('brand', v.brandId);
      await getVehicleModels(v.brandId, false);
      await waitForNextPaint();
    } else {
      setValue('brand', v.brandId);
    }
    setValue('model', v.modelId);

    if (v.stateId) {
      setValue('state', v.stateId);
      await getCities(v.stateId, false);
      await waitForNextPaint();
    } else {
      setValue('state', v.stateId);
    }
    setValue('city', v.cityId);
    if (v.cityId) {
      await getMunicipalities(v.cityId, false);
      await waitForNextPaint();
    }
    setValue('municipality', v.municipalityId);
    setValue('address', v.address);
    setValue('addressReference', v.addressReference);

    setValue('ownerState', v.ownerStateId);
    if (v.ownerStateId) {
      await getOwnerCities(v.ownerStateId);
      await waitForNextPaint();
    }
    setValue('ownerCity', v.ownerCityId);
    setValue('ownerAddress', v.ownerAddress);

    setValue('plate', v.plate);
    setValue('color', capitalize(v.color));
    setValue('km', v.km);
    setValue('bodySerial', v.bodySerial);
    setValue('titleNumber', v.titleNumber);
    setValue('year', v.year);
    setValue('armored', v.armored);
    setValue('economicActivity', c?.economicActivity);
    setValue('otherEconomicActivity', c?.otherEconomicActivity);

    if (r?.state) {
      await getRCVCities(r.state);
      await waitForNextPaint();
    }
    setValue('rcvHolderFirstName', r?.firstName);
    setValue('rcvHolderLastName', r?.lastName);
    setValue('rcvHolderIdentificationType', r?.identificationType);
    setValue('rcvHolderIdentification', r?.identification);
    setValue('rcvHolderPhonePrefix', r?.phonePrefix);
    setValue('rcvHolderPhoneNumber', r?.phoneNumber);
    setValue('rcvHolderCity', r?.city);
    setValue('rcvHolderAddress', r?.address);
    setValue(
      'isVehicleDriver',
      r?.isVehicleDriver === false ? 'false' : 'true'
    );
  };

  const editVehicle = handleSubmit(async (data) => {
    let dataToPost = { ...data };
    dataToPost.membership = membership?._id;
    dataToPost.rcvHolder = {
      isVehicleDriver: data?.isVehicleDriver,
      firstName: data?.rcvHolderFirstName,
      lastName: data?.rcvHolderLastName,
      fullName: `${data?.rcvHolderFirstName} ${data?.rcvHolderLastName}`,
      identification: data?.rcvHolderIdentification,
      identificationType: data?.rcvHolderIdentificationType,
      phonePrefix: data?.rcvHolderPhonePrefix,
      phoneNumber: data?.rcvHolderPhoneNumber,
      state: data?.rcvHolderState,
      city: data?.rcvHolderCity,
      address: data?.rcvHolderAddress,
    };

    dataToPost.rcvHolder = filterParams(dataToPost?.rcvHolder);

    delete dataToPost?.contractType;
    delete dataToPost?.affiliationType;
    delete dataToPost?.isVehicleDriver;
    delete dataToPost?.rcvHolderFirstName;
    delete dataToPost?.rcvHolderLastName;
    delete dataToPost?.rcvHolderIdentification;
    delete dataToPost?.rcvHolderIdentificationType;
    delete dataToPost?.rcvHolderPhonePrefix;
    delete dataToPost?.rcvHolderPhoneNumber;
    delete dataToPost?.rcvHolderState;
    delete dataToPost?.rcvHolderCity;
    delete dataToPost?.rcvHolderAddress;

    if (
      (dataToPost.rcvHolder.firstName === '' ||
        dataToPost.rcvHolder.firstName === undefined) &&
      (dataToPost.rcvHolder.lastName === '' ||
        dataToPost.rcvHolder.lastName === undefined)
    ) {
      delete dataToPost.rcvHolder.fullName;
    }
    dataToPost = filterParams(dataToPost);
    if (!isLoading) {
      setIsloading(true);
      vehicleService
        .updateVehicle(dataToPost, membership?.vehicle?._id)
        .then((response) => {
          if ([200, 201].includes(response.status)) {
            notify(`Datos actualizados`, 'success');
            reloadMembership();
            setIsloading(false);
          } else {
            notify(`${response.message}`, 'error');
            setIsloading(false);
          }
        })
        .catch((error) => {
          setIsloading(false);
        });
    }
  });

  const getVehicleBrands = () => {
    return vehicleService
      .getVehicleBrands(undefined, getVehicleBrandsPlanParam(membership))
      .then((response) => {
        if (response.status === 200) {
          setVehicleBrandOptions(response?.data?.vehicleBrands);
        } else {
          notify(`${response.message}`, 'error');
        }
        return response;
      })
      .catch(() => {});
  };

  const getSalesVehicleClasses = (membership) => {
    return vehicleService
      .getSalesVehicleClasses()
      .then((response) => {
        if (response.status === 200) {
          const classes = response?.data?.classes;
          const classId = resolveVehicleClassId(classes, membership?.vehicle);
          setVehicleClassesOptions(classes);
          filterVehicleUse(classes, classId);
          setValue('vehicleUsage', membership?.vehicle?.vehicleUsage);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
        return response;
      })
      .catch(() => {});
  };

  const handleVehicleType = () => {
    getVehicleTypes(watch('class'));
    filterVehicleUse(vehicleClassesOptions, watch('class'));
    setValue('vehicleUsage', '');
  };

  const getVehicleTypes = (vehicleClass, changeVehicle) => {
    if (!vehicleClass) {
      return Promise.resolve();
    }
    return vehicleService
      .getVehicleTypes({
        class: vehicleClass ? vehicleClass : watch('class'),
      })
      .then((response) => {
        if (response.status === 200) {
          if (changeVehicle) {
            setVehicleChangeTypesOptions(response?.data?.types);
          } else {
            setTypesOptions(response?.data?.types);
          }
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
        return response;
      })
      .catch(() => {});
  };

  const getVehicleModels = (brand, changeVehicle) => {
    return vehicleService
      .getVehicleModels(brand ? brand : watch('brand'))
      .then((response) => {
        if (response.status === 200) {
          if (changeVehicle) {
            setVehicleChangeModelOptions(response?.data?.models);
          } else {
            setVehicleModelOptions(response?.data?.models);
          }
        } else {
          notify(`${response.message}`, 'error');
        }
        return response;
      })
      .catch(() => {});
  };

  const getStates = () => {
    return statesService
      .getStates({ isActive: true })
      .then((response) => {
        if (response.status === 200) {
          setStatesOptions(response?.data?.states);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
        return response;
      })
      .catch(() => {});
  };

  const getOwnerCities = (ownerState) => {
    if (!ownerState && !watch('ownerState')) {
      return Promise.resolve();
    }
    return statesService
      .getCities(ownerState ? ownerState : watch('ownerState'))
      .then((response) => {
        if (response.status === 200) {
          setOwnerCitiesOptions(response?.data?.cities);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
        return response;
      })
      .catch(() => {});
  };

  const getRCVCities = (RCVCities) => {
    if (!RCVCities && !watch('ownerState')) {
      return Promise.resolve();
    }
    return statesService
      .getCities(RCVCities ? RCVCities : watch('ownerState'))
      .then((response) => {
        if (response.status === 200) {
          setRCVCitiesOptions(response?.data?.cities);
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
        return response;
      })
      .catch(() => {});
  };

  const getCities = (state, changeVehicle) => {
    if (!state && !watch('state')) {
      return Promise.resolve();
    }
    return statesService
      .getCities(state ? state : watch('state'))
      .then((response) => {
        if (response.status === 200) {
          if (changeVehicle) {
            setVehicleChangeOwnerCitiesOptions(response?.data?.cities);
          } else {
            setCitiesOptions(response?.data?.cities);
          }
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
        return response;
      })
      .catch(() => {});
  };

  const getMunicipalities = (city, changeVehicle) => {
    if (!city && !watch('city')) {
      return Promise.resolve();
    }
    return statesService
      .getMunicipalities(city ? city : watch('city'))
      .then((response) => {
        if (response.status === 200) {
          if (changeVehicle) {
            setVehicleChangeMunicipalitiesOptions(
              response?.data?.municipalities
            );
          } else {
            setMunicipalitiesOptions(response?.data?.municipalities);
          }
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
        return response;
      })
      .catch(() => {});
  };

  const setVehicleAsSold = () => {
    vehicleService
      .updateToSold(membership.vehicle?._id)
      .then((response) => {
        if (response.status === 200) {
          handleVehicleSoldModal();
          reloadMembership();
        } else {
          notify(`${response.message}` || 'error', 'error');
        }
      })
      .catch(() => {});
  };

  const handleCity = (e) => {
    getRCVCities(e.target.value);
  };

  const handlecustomerIsOwner = (e) => {
    if (e?.target?.value === 'SI') {
      setValue('customerIsOwner', true);
      setcustomerIsOwner(e?.target?.value);
      // clearTitularForm();
    }
    if (e?.target?.value === 'NO') {
      setValue('customerIsOwner', false);
      setcustomerIsOwner(e?.target?.value);
      // clearTitularForm();
    }
  };

  const handleMissingFieldModal = (missingFields) => {
    setMissingFieldsModal((prevState) => {
      return {
        ...prevState,
        isOpen: !missingFieldsModal?.isOpen,
        missingFields: missingFields ? missingFields : [],
      };
    });
  };

  const handleMissingDocumentsModal = (missingDocuments) => {
    setMissingDocumentsModal((prevState) => {
      return {
        ...prevState,
        isOpen: !missingDocumentsModal?.isOpen,
        missingDocuments: missingDocuments ? missingDocuments : [],
      };
    });
  };

  const validatePlateAndYear = () => {
    return false;
  };

  const checkMissingValues = () => {
    if (isPendingDocumentation) {
      return;
    }

    const requiredFields = {
      class: membership?.vehicle?.classId,
      type: membership?.vehicle?.typeId,
      brand: membership?.vehicle?.brandId,
      municipality: membership?.vehicle?.municipalityId,
      model: membership?.vehicle?.modelId,
      state: membership?.vehicle?.stateId,
      city: membership?.vehicle?.cityId,
      address: membership?.vehicle?.address,
    };

    const requiredDocuments = {
      circulationCard: membership?.vehicle?.circulationCard,
      identityDocument: membership?.customer?.identityDocument,
      licenses:
        membership?.customer?.licenses?.length > 0
          ? membership?.customer?.licenses[0]
          : '',
    };

    // Required Values
    const documentLabels = [
      { label: 'circulationCard', name: 'Titulo de propiedad' },
      { label: 'licenses', name: 'Licencia' },
      { label: 'identityDocument', name: 'Cédula' },
    ];

    // Required Values
    const labels = [
      { label: 'class', name: 'Clase' },
      { label: 'type', name: 'Tipo' },
      { label: 'model', name: 'Modelo' },
      { label: 'brand', name: 'Marca' },
      { label: 'state', name: 'Estado' },
      { label: 'city', name: 'Genero' },
      { label: 'municipality', name: 'Municipio' },
      { label: 'address', name: 'Dirección' },
    ];

    let missingDocuments = returnMissingFields(
      documentLabels,
      requiredDocuments
    );
    if (missingDocuments?.length > 0) {
      handleMissingDocumentsModal(missingDocuments);
    }

    let missingFields = returnMissingFields(labels, requiredFields);
    if (missingFields?.length > 0) {
      handleMissingFieldModal(missingFields);
    }
  };

  const validateTruck = (watch) => {
    const [camion] = vehicleClassesOptions?.filter((option) =>
      [vehiclesEnum?.CAMION]?.includes(option.name)
    );

    if (watch('class') === camion?._id) {
      return true;
    } else return false;
  };

  const handleChangeVehicleModal = () => {
    setChangeVehicleModal((prevState) => {
      return {
        ...prevState,
        isOpen: !changeVehicleModal?.isOpen,
      };
    });
  };

  const handleVehicleSoldModal = () => {
    setChangeVehicleSoldModal((prevState) => {
      return {
        ...prevState,
        isOpen: !changeVehicleSoldModal?.isOpen,
      };
    });
  };

  const handleVehicleHistoryModal = () => {
    setVehicleHistoryModal((prevState) => {
      return {
        ...prevState,
        isOpen: !vehicleHistoryModal?.isOpen,
      };
    });
  };

  const filterVehicleUse = (vehicleClasses, clase) => {
    const _class = filterById(vehicleClasses, clase);
    if ([vehiclesEnum?.AUTOMOVIL].includes(_class.name)) {
      setVehicleFilerUsageOptions(
        vehicleUsageOptions?.filter((option) =>
          [vehicleUsageEnum.PUBLIC, vehicleUsageEnum.PARTICULAR].includes(
            option?._id
          )
        )
      );
    }
    if ([vehiclesEnum?.CAMIONETA].includes(_class.name)) {
      setVehicleFilerUsageOptions(
        vehicleUsageOptions?.filter((option) =>
          [
            vehicleUsageEnum.PUBLIC,
            vehicleUsageEnum.PARTICULAR,
            vehicleUsageEnum.LOAD,
          ].includes(option?._id)
        )
      );
    }
    if ([vehiclesEnum?.RUSTICO].includes(_class.name)) {
      setVehicleFilerUsageOptions(
        vehicleUsageOptions?.filter((option) =>
          [
            vehicleUsageEnum.PUBLIC,
            vehicleUsageEnum.PARTICULAR,
            vehicleUsageEnum.LOAD,
          ].includes(option?._id)
        )
      );
    }
    if ([vehiclesEnum?.MOTO].includes(_class.name)) {
      setVehicleFilerUsageOptions(
        vehicleUsageOptions?.filter((option) =>
          [vehicleUsageEnum.PARTICULAR, vehicleUsageEnum.LOAD].includes(
            option?._id
          )
        )
      );
    }
    if ([vehiclesEnum?.TRIMOTO].includes(_class.name)) {
      setVehicleFilerUsageOptions(
        vehicleUsageOptions?.filter((option) =>
          [vehicleUsageEnum.LOAD].includes(option?._id)
        )
      );
    }
    if ([vehiclesEnum?.CAMION, vehiclesEnum?.GRUA].includes(_class.name)) {
      setVehicleFilerUsageOptions(
        vehicleUsageOptions?.filter((option) =>
          [vehicleUsageEnum.LOAD, vehicleUsageEnum.TOW].includes(option?._id)
        )
      );
    }
    if ([vehiclesEnum?.AMBULANCIA].includes(_class.name)) {
      setVehicleFilerUsageOptions(
        vehicleUsageOptions?.filter((option) =>
          [vehicleUsageEnum.LOAD].includes(option?._id)
        )
      );
    }
    if ([vehiclesEnum?.AUTOBUS, vehiclesEnum?.MINIBUS].includes(_class.name)) {
      setVehicleFilerUsageOptions(
        vehicleUsageOptions?.filter((option) =>
          [vehicleUsageEnum.PUBLIC, vehicleUsageEnum.PARTICULAR].includes(
            option?._id
          )
        )
      );
    }
    if (!_class.name) {
      setVehicleFilerUsageOptions(vehicleUsageOptions);
    }
  };

  useEffect(() => {
    if (!open) return;

    let cancelled = false;
    (async () => {
      await preloadForm();
      if (!cancelled) checkMissingValues();
    })();
    return () => {
      cancelled = true;
    };
    // Preload and missing-field check intentionally follow membership/open, not callback identities
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, membership?._id]);

  return (
    <>
      <ChangeVehicleModal
        modal={changeVehicleModal}
        handleModal={handleChangeVehicleModal}
        register={register2}
        errors={errors2}
        action={changeVehicle}
        validateTruck={validateTruck}
        reset={reset2}
        watch={watch2}
        onChange={{
          getVehicleModels: getVehicleModels,
          getVehicleTypes: getVehicleTypes,
          getCities: getCities,
          getMunicipalities: getMunicipalities,
        }}
        options={{
          vehicleClassesOptions: vehicleClassesOptions,
          vehicleBrandOptions: vehicleBrandOptions,
          vehicleChangeModelOptions: vehicleChangeModelOptions,
          vehicleChangetypesOptions: vehicleChangetypesOptions,
          statesOptions: statesOptions,
          affiliationTypeOptions: affiliationTypeOptions,
          armoredOptions: armoredOptions,
          vehicleChangeOwnercitiesOptions: vehicleChangeOwnercitiesOptions,
          vehicleChangeMunicipalitiesOptions:
            vehicleChangeMunicipalitiesOptions,
          vehicleWeightOptions: vehicleWeightOptions,
        }}
      />

      <VehicleChangeHistoryModal
        modal={vehicleHistoryModal}
        handleModal={handleVehicleHistoryModal}
        header={vehicleChangeHistoryHeader}
        data={membership?.vehicleHistory}
      />
      <VehicleSoldModal
        modal={changeVehicleSoldModal}
        handleModal={handleVehicleSoldModal}
        header={vehicleChangeHistoryHeader}
        action={setVehicleAsSold}
        data={membership?.vehicleHistory}
      />

      <LoadSpinner show={isLoading} />
      <MissingFieldsModal
        modal={missingFieldsModal}
        handleModal={handleMissingFieldModal}
      />

      <MissingDocumentsModal
        modal={missingDocumentsModal}
        handleModal={handleMissingDocumentsModal}
      />
      <div className="order-card">
        <OderCardHeader open={open} setOpen={setOpen} label={label} />

        {open && (
          <>
            {!isPendingDocumentation && (
              <div className="change-flow-button-container">
                <span></span>
                <div className="buttons-container">
                  {membership?.vehicleHistory?.length > 0 ? (
                    <ActionButton
                      label={'Historico de Vehiculos'}
                      action={handleVehicleHistoryModal}
                    />
                  ) : (
                    <span></span>
                  )}
                  {[
                    salesRoles?.SALES_ADMIN,
                    salesRoles?.SALES_DEVELOPER,
                    salesRoles?.SALES_HUNTER,
                    salesRoles?.SALES_FARMER,
                    salesRoles?.SALES_KEY_ACCOUNTS,
                  ]?.includes(authService?.getUserType())}
                  <ActionButton
                    label={'Cambio de Vehiculo'}
                    action={handleChangeVehicleModal}
                  />
                  {!membership?.vehicle?.sold && (
                    <ActionButton
                      label={'Vehiculo Vendido'}
                      action={handleVehicleSoldModal}
                    />
                  )}
                </div>
              </div>
            )}

            <br />

            {membership?.vehicle?.sold && (
              <div className="vehicle-sold-component">
                <h6>Vehiculo vendido</h6>
              </div>
            )}

            <div className="buttons-container">
              <h6 style={{ margin: '6px 12px 12px 0px' }}>
                DATOS DEL VEHÍCULO
              </h6>
              {!isPendingDocumentation && (
                <ActionButton label={'Guardar'} action={editVehicle} />
              )}
            </div>
            <fieldset
              disabled={isPendingDocumentation}
              style={{ border: 'none', padding: 0, margin: 0, minWidth: 0 }}
            >
            <p style={{ margin: '0px' }}>(*) Campos obligatorios</p>
            <div style={{ width: '100%' }} className="row">
              <Input
                bootstrap={'col-12 col-md-4'}
                label={'Clase *'}
                type={'select'}
                options={vehicleClassesOptions}
                name={'class'}
                register={register}
                placeholder={''}
                onChange={() => handleVehicleType()}
                errors={errors?.class?.message}
              />
              <Input
                bootstrap={'col-12 col-md-4'}
                label={'Marca *'}
                type={'select'}
                options={vehicleBrandOptions}
                name={'brand'}
                register={register}
                placeholder={''}
                errors={errors?.brand?.message}
                onChange={() => getVehicleModels(watch('brand'), false)}
              />
              <Input
                bootstrap={'col-12 col-md-4'}
                label={'Modelo *'}
                type={'select'}
                options={vehicleModelOptions}
                name={'model'}
                register={register}
                placeholder={''}
                errors={errors?.model?.message}
              />
              <Input
                bootstrap={'col-12 col-md-4'}
                label={'Tipo *'}
                type={'select'}
                options={typesOptions}
                name={'type'}
                register={register}
                placeholder={''}
                errors={errors?.type?.message}
              />
              {validateTruck(watch) && (
                <Input
                  bootstrap={'col-12 col-md-4'}
                  label={'Peso del Camion *'}
                  type={'select'}
                  options={vehicleWeightOptions}
                  name={'truckWeight'}
                  register={register}
                  placeholder={''}
                  errors={errors?.truckWeight?.message}
                />
              )}
              <Input
                bootstrap={'col-12 col-md-4'}
                label={'Año *'}
                type={'number'}
                name={'year'}
                register={register}
                placeholder={''}
                errors={errors?.year?.message}
                min={'1990'}
                max={new Date().getFullYear() + 1}
                disabled={validatePlateAndYear()}
              />
              <Input
                bootstrap={'col-12 col-md-4'}
                label={'Color *'}
                type={'text'}
                name={'color'}
                register={register}
                placeholder={''}
                errors={errors?.color?.message}
              />
              <Input
                bootstrap={'col-12 col-md-4'}
                label={'Placa *'}
                type={'text'}
                name={'plate'}
                register={register}
                placeholder={''}
                errors={errors?.plate?.message}
                onChange={(e) =>
                  removeSpecialCharsAndUppercase(
                    watch('plate'),
                    'plate',
                    setValue
                  )
                }
                disabled={validatePlateAndYear()}
              />
              <Input
                bootstrap={'col-12 col-md-4'}
                label={'Kilometraje del Vehículo *'}
                type={'number'}
                name={'km'}
                register={register}
                placeholder={''}
                errors={errors?.km?.message}
                min={'0'}
              />
              <Input
                bootstrap={'col-12 col-md-4'}
                label={'Blindaje *'}
                type={'select'}
                name={'armored'}
                options={armoredOptions}
                register={register}
                placeholder={''}
                errors={errors?.armored?.message}
              />
              <Input
                bootstrap={'col-12 col-md-4'}
                label={'Estado *'}
                type={'select'}
                options={statesOptions}
                name={'state'}
                register={register}
                placeholder={''}
                errors={errors?.state?.message}
                onChange={() => getCities(watch('state'), false)}
              />{' '}
              <Input
                bootstrap={'col-12 col-md-4'}
                label={'Ciudad *'}
                type={'select'}
                options={citiesOptions}
                name={'city'}
                register={register}
                placeholder={''}
                errors={errors?.city?.message}
                onChange={() => getMunicipalities(watch('city'), false)}
              />{' '}
              <Input
                bootstrap={'col-12 col-md-4'}
                label={'Municipio'}
                type={'select'}
                options={municipalitiesOptions}
                name={'municipality'}
                register={register}
                placeholder={''}
                errors={errors?.municipality?.message}
              />
              <Input
                bootstrap={'col-12 col-md-4'}
                label={'Dirección *'}
                type={'textarea'}
                name={'address'}
                register={register}
                placeholder={''}
                errors={errors?.address?.message}
              />
              <Input
                bootstrap={'col-12 col-md-4'}
                label={'Dirección Referencia'}
                type={'textarea'}
                name={'addressReference'}
                register={register}
                placeholder={''}
                errors={errors?.addressReference?.message}
              />
              <div className="col-12"></div>
              <h6>DATOS DEL RCV</h6>
              <Input
                bootstrap={'col-12 col-md-4'}
                label={'Serial Carrocería *'}
                type={'text'}
                name={'bodySerial'}
                register={register}
                placeholder={''}
                errors={errors?.bodySerial?.message}
              />{' '}
              <Input
                bootstrap={'col-12 col-md-4'}
                label={'Serial Motor '}
                type={'text'}
                name={'engineSerial'}
                register={register}
                placeholder={''}
                errors={errors?.engineSerial?.message}
                onChange={(e) =>
                  removeSpecialCharsAndUppercase(
                    watch('engineSerial'),
                    'engineSerial',
                    setValue
                  )
                }
              />
              <Input
                bootstrap={'col-12 col-md-4'}
                label={'Puestos del Vehículo *'}
                type={'number'}
                name={'seats'}
                register={register}
                placeholder={''}
                errors={errors?.seats?.message}
              />
              <Input
                bootstrap={'col-12 col-md-4'}
                label={'Uso del Vehículo *'}
                type={'select'}
                options={vehicleFilerUsageOptions}
                name={'vehicleUsage'}
                register={register}
                placeholder={''}
                errors={errors?.vehicleUsage?.message}
              />
              <Input
                bootstrap={'col-12 col-md-4'}
                label={'Profesión/Ocupación '}
                type={'text'}
                name={'profession'}
                register={register}
                placeholder={''}
                errors={errors?.profession?.message}
              />
              <Input
                bootstrap={'col-12 col-md-4'}
                label={'Actividad Económica'}
                type={'select'}
                options={economicActivitiesOptions}
                name={'economicActivity'}
                register={register}
                placeholder={''}
                onChange={() => setValue('otherEconomicActivity', '')}
                errors={errors?.economicActivity?.message}
              />
              {(validateIfOther(watch, economicActivitiesOptions) ||
                membership?.customer?.otherEconomicActivity) && (
                <Input
                  bootstrap={'col-12 col-md-4'}
                  label={'Otra Actividad Económica *'}
                  type={'text'}
                  name={'otherEconomicActivity'}
                  register={register}
                  placeholder={''}
                  errors={errors?.otherEconomicActivity?.message}
                />
              )}
              <Input
                bootstrap={'col-12 col-md-4'}
                label={'Número de Título de Propiedad*'}
                type={'text'}
                name={'titleNumber'}
                register={register}
                placeholder={''}
                errors={errors?.titleNumber?.message}
                onChange={(e) =>
                  removeSpecialCharsAndUppercase(
                    watch('titleNumber'),
                    'titleNumber',
                    setValue
                  )
                }
              />
              <div className="col-12 col-md-6 checbox-input-container">
                <label htmlFor="">¿Eres el titular del vehículo?</label>
                <div className="checbox-input-container-midle">
                  <div className="topping">
                    <input
                      type="checkbox"
                      id="topping"
                      name="customerIsOwner"
                      value={'SI'}
                      checked={customerIsOwner === 'SI'}
                      onChange={handlecustomerIsOwner}
                    />
                    Si
                  </div>{' '}
                  <div className="topping">
                    <input
                      type="checkbox"
                      id="topping"
                      name="customerIsOwner"
                      value={'NO'}
                      checked={customerIsOwner === 'NO'}
                      onChange={handlecustomerIsOwner}
                    />
                    No
                  </div>
                </div>
              </div>
            </div>
            {customerIsOwner === 'NO' && (
              <>
                <h6>DATOS DEL TITULAR</h6>
                <p style={{ margin: '0px' }}>(*) Campos obligatorios</p>
                <div style={{ width: '100%' }} className="row">
                  <Input
                    bootstrap={'col-12 col-md-4'}
                    label={'Nombre *'}
                    type={'text'}
                    name={'ownerFirstName'}
                    register={register}
                    placeholder={''}
                    errors={errors?.ownerFirstName?.message}
                  />{' '}
                  <Input
                    bootstrap={'col-12 col-md-4'}
                    label={'Apellido *'}
                    type={'text'}
                    name={'ownerLastName'}
                    register={register}
                    placeholder={''}
                    errors={errors?.ownerLastName?.message}
                  />
                  <Input
                    bootstrap={'col-4 col-sm-1 col-md-1'}
                    label={'C.I / RIF*'}
                    type={'select'}
                    name={'ownerIdentificationType'}
                    register={register}
                    placeholder={''}
                    options={idCodes}
                    errors={errors?.ownerIdentificationType?.message}
                  />{' '}
                  <Input
                    bootstrap={'col-8 col-sm-3 col-md-3'}
                    label={'del titular*'}
                    type={'number'}
                    name={'ownerIdentification'}
                    register={register}
                    placeholder={''}
                    errors={errors?.ownerIdentification?.message}
                  />{' '}
                  <Input
                    bootstrap={'col-12 col-md-4'}
                    label={'Estado *'}
                    type={'select'}
                    options={statesOptions}
                    name={'ownerState'}
                    register={register}
                    placeholder={''}
                    errors={errors?.ownerState?.message}
                    onChange={() => getOwnerCities(watch('ownerState'))}
                  />
                  <Input
                    bootstrap={'col-12 col-md-4'}
                    label={'Ciudad *'}
                    type={'select'}
                    options={ownercitiesOptions}
                    name={'ownerCity'}
                    register={register}
                    placeholder={''}
                    errors={errors?.ownerCity?.message}
                  />{' '}
                  <Input
                    bootstrap={'col-12 col-md-4'}
                    label={'Dirección de domicilio *'}
                    type={'textarea'}
                    name={'ownerAddress'}
                    register={register}
                    placeholder={''}
                    errors={errors?.ownerAddress?.message}
                  />
                </div>
              </>
            )}
            <RcvHolderFormForAffiliationCard
              register={register}
              errors={errors}
              setValue={setValue}
              watch={watch}
              citiesOptions={RCVCitiesOptions}
              statesOptions={statesOptions}
              handleCity={handleCity}
            />
            </fieldset>
          </>
        )}
      </div>
    </>
  );
};
